import {
  AfterViewInit,
  Directive,
  Input,
  Renderer2
} from '@angular/core';
import { IonContent } from '@ionic/angular';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Directive({
  selector: '[animationHome]'
})
export class AnimationHomeDirective implements AfterViewInit {
  @Input() animationContent;
  @Input() set animationToolbar(toolbar: any) {
    this.toolbar = toolbar && toolbar.el;
  }

  private content: HTMLElement;
  private toolbar: HTMLElement;
  private scrollHeight: number;

  constructor(
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    this.content = document.getElementsByTagName('ion-backdrop').item(0);

    const hasScrolledDown$ = (this.animationContent as IonContent).ionScroll.pipe(
      map(ev => {
        this.scrollHeight = document.getElementsByTagName('app-user-section')?.item(0)?.querySelector(
          '.user-section'
        ).clientHeight;
        if (this.scrollHeight) {
          this.setOpacity(ev.detail.scrollTop);
          this.setHeaderStyle(ev.detail.scrollTop);
          return ev.detail.scrollTop > 0;
        } else {
          this.setHeaderStyle(ev.detail.scrollTop);
          return false;
        }
      }),
      distinctUntilChanged()
    );
    hasScrolledDown$.subscribe(hasScrolledDown => {
      hasScrolledDown ? this.enableBackdrop() : this.disableBackdrop();
    });
  }

  private enableBackdrop() {
    this.renderer.setStyle(this.content, 'visibility', 'visible');
  }

  private disableBackdrop() {
    this.renderer.setStyle(this.content, 'visibility', 'hidden');
  }

  private setOpacity(scrollTop) {
    this.renderer.setStyle(this.content, 'opacity', scrollTop / this.scrollHeight);
  }

  private setHeaderStyle(scrollTop) {
    if (scrollTop < this.scrollHeight) {
      this.renderer.setAttribute(this.toolbar, 'color', 'primary');
      this.renderer.setStyle(this.toolbar, 'opacity', ((this.scrollHeight - scrollTop) / this.scrollHeight));
    } else {
      this.renderer.setAttribute(this.toolbar, 'color', 'base');
      this.renderer.setStyle(this.toolbar, 'opacity', 1);
    }
  }

}
